<template>
  <div class="card">
    <h3>Yritykset</h3>
    <div v-for="company in sortedCompanies" :key="company.id" class="company">
      <div
        class="company__logo"
        :style="{ backgroundImage: `url(${company.image})` }"
      ></div>
      <div class="company__name">
        {{ company.name }} <br />
        <span>Käyttäjiä: {{ company.users.length }}</span>
      </div>
      <!-- <div class="company__users">Käyttäjiä: {{ company.users.length }}</div> -->
      <div class="company__settings">
        <i
          @click="
            $router.push({
              name: 'EditCompany',
              params: { company_slug: company.slug, companyId: company.id }
            })
          "
          class="icon icon--edit company__icon"
        ></i>
        <i
          @click="deleteCompany(company.id)"
          class="icon icon--x company__icon"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
import db from "@/firebase/init";
import firebase from "firebase";
import { mapState } from "vuex";

export default {
  data() {
    return {
      companies: [],
      users: [],
      userBelongsToCompany: null
    };
  },
  computed: {
    ...mapState(["user", "company"]),

    sortedCompanies() {
      const users = this.users.map(usr => usr);
      // const companies = this.companies.map(comp => comp);
      const companies = Object.keys(this.companies).map(
        slug => this.companies[slug]
      );

      companies.filter(c => {
        c.users = [];
        const equal = users.some(u => {
          if (c.id === u.companyId) {
            c.users.push(u);
          }
          return equal;
        });
      });

      return [...companies].sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
    }
  },
  methods: {
    deleteEvent(id) {
      db.collection("companies")
        .doc(id)
        .delete()
        .then(() => {
          this.companies = this.companies.filter(company => {
            return company.id !== id;
          });
        });
    },
    updateUsers() {
      db.collection("users")
        .get()
        .then(snapshot => {
          this.users = [];
          snapshot.forEach(doc => {
            let user = doc.data();
            user.id = doc.id;
            this.users.push(user);
          });
        });
    },
    deleteCompany (id) {
      const logoRef = firebase.storage().ref('logos/' + 'logo-'+id);

      db.collection("companies").doc(id).delete().then(() => {
        console.log("Document successfully deleted!");
        logoRef.delete().then(function() {
          console.log("Logo successfully deleted!");
        }).catch(function(error) {
          console.error("Error removing logo: ", error);
        });
      }).catch((error) => {
        console.error("Error removing document: ", error);
      });
    }
  },
  created() {
    this.updateUsers();
    db.collection("companies").onSnapshot(snapshot => {
      this.companies = [];
      snapshot.forEach(doc => {
        let company = doc.data();
        company.id = doc.id;
        this.companies.push(company);
      });
    });
  }
};
</script>

<style lang="scss">
.company {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 1em 0;
  border-bottom: 1px solid $gray;
  &__logo {
    width: 2em;
    height: 2em;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 50%;
    box-shadow: $shadow_sm;
    @include bp(sm) {
      width: 2.5em;
      height: 2.5em;
    }
  }
  &__name {
    margin: 0 2em;
    color: black;
    span {
      font-size: 1.4rem;
    }
  }
  &__settings {
    margin-left: auto;
  }
  &__icon {
    padding: 10px;
    box-shadow: $shadow_sm;
    border-radius: 50%;
    background-size: 50%;
    cursor: pointer;
    transition: $transition;
    @include bp(sm) {
      padding: 1em;
    }
    &:hover {
      box-shadow: $shadow_md;
      transition: $transition;
    }
  }
}
</style>
